import { Dispatch } from "redux"

import validateStatusResponse from "utils/validation/validate-status"
import ApiEventTypes from "api/ApiEventTypes"
import { CLEAN_EVENT_TYPE, CLOSE_MODAL, OPEN_MODAL, SET_EVENT_TYPE } from "./actions-types"
import isInvalidInput from "./event-types-validation"

export function changeModalState(isOpen: boolean, type: "create" | "update" | "delete" | "") {
  return (dispatch: Dispatch) => {
    if (isOpen) return dispatch({ type: OPEN_MODAL, payload: { type } })

    return dispatch({ type: CLOSE_MODAL })
  }
}

export function setEventType(params: App.EventTypesRequest) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: SET_EVENT_TYPE,
      payload: params
    })
  }
}

export function cleanEvenType() {
  return (dispatch: Dispatch) => {
    dispatch({ type: CLEAN_EVENT_TYPE })
  }
}

export function submitEventType(data: App.EventTypesSubmitPayload, type: "update" | "create") {
  let statusCode: number

  return async (dispatch: Dispatch) => {
    const { isInvalid, msg } = isInvalidInput(data, type)

    if (isInvalid) return msg

    const price = data.price

    if (type === "create") {
      const { status } = await new ApiEventTypes().create({ ...data, price })

      statusCode = status
    }

    if (type === "update") {
      const { status } = await new ApiEventTypes().updateByKey({
        ...data,
        price
      })

      statusCode = status
    }

    return validateStatusResponse(statusCode, dispatch)
  }
}

export function deleteEventType(key: string) {
  return async (dispatch: Dispatch) => {
    const { status } = await new ApiEventTypes().deleteByKey(key)

    return validateStatusResponse(status, dispatch)
  }
}
